export default "__VITE_ASSET__Cw3_B20h__"